/* iFurb "Build your colours" picker for custom iPod builds.
   Saves Faceplate / Centre button / Clickwheel / Rear cover / Headphone jack & bezel as line item properties
   and blocks Add to cart (and Buy it now) until all five are chosen (jack & bezel defaults to White). */
(function () {
  if (window.customElements && customElements.get('custom-build-colours')) return;

  var PARTS = ['faceplate', 'button', 'wheel', 'rear', 'jack'];
  var LABELS = { faceplate: 'Faceplate', button: 'Centre button', wheel: 'Clickwheel', rear: 'Rear cover', jack: 'Headphone jack & bezel' };
  class CBC extends HTMLElement {}

  CBC.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    var self = this;
    this.form = document.getElementById(this.dataset.formId);
    this.rows = {};
    Array.prototype.forEach.call(this.querySelectorAll('.cbc-row'), function (r) { self.rows[r.dataset.part] = r; });
    this.statusEl = this.querySelector('[data-cbc-status]');
    this.matchBtn = this.querySelector('[data-cbc-match]');

    this.addEventListener('change', function (e) {
      if (e.target && e.target.classList && (e.target.classList.contains('cbc-input') || e.target.classList.contains('cbc-jack-input'))) self.update();
    });
    if (this.matchBtn) {
      this.matchBtn.addEventListener('click', function () {
        var target = self.matchTarget();
        if (target) { target.checked = true; self.update(); }
      });
    }

    // Block the theme's AJAX add (capture phase runs before the theme's own submit listener).
    this._onSubmit = function (e) {
      if (!self.form || e.target !== self.form) return;
      if (!self.complete()) { e.preventDefault(); e.stopImmediatePropagation(); self.nag(); }
    };
    document.addEventListener('submit', this._onSubmit, true);
    // Block Buy it now / dynamic checkout until complete.
    this._onClick = function (e) {
      var t = e.target;
      if (!t || !t.closest || !self.form) return;
      var pb = t.closest('.shopify-payment-button');
      var atc = t.closest('.single-add-to-cart-button');
      var hit = (pb && self.form.contains(pb)) || (atc && (atc.form === self.form || self.form.contains(atc)));
      if (hit && !self.complete()) { e.preventDefault(); e.stopImmediatePropagation(); self.nag(); }
    };
    document.addEventListener('click', this._onClick, true);

    if (this.form && !this.form.querySelector('.cbc-cart-hint')) {
      this.hint = document.createElement('p');
      this.hint.className = 'cbc-cart-hint';
      this.hint.setAttribute('role', 'note');
      this.hint.textContent = 'Choose all 5 colours above (faceplate, centre button, clickwheel, rear cover and headphone jack & bezel) to add to cart.';
      var holder = this.form.querySelector('.product-add-to-cart-container') || this.form.firstChild;
      this.form.insertBefore(this.hint, holder);
    }
    this.setupJack();
    this.update();
  };

  /* Headphone jack & bezel row: saved as the line item property "Headphone jack & bezel" (White preselected). */
  CBC.prototype.setupJack = function () {
    var self = this, row = this.querySelector('.cbc-row--jack');
    if (!row) return;
    var sync = function () {
      var c = row.querySelector('.cbc-jack-input:checked');
      if (!c) { c = row.querySelector('.cbc-jack-input[value="White"]') || row.querySelector('.cbc-jack-input'); if (c) c.checked = true; }
      var lbl = row.querySelector('[data-cbc-jack-value]');
      if (lbl && c) lbl.textContent = c.value;
    };
    this.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('cbc-jack-input')) sync();
    });
    sync();
  };

  CBC.prototype.disconnectedCallback = function () {
    document.removeEventListener('submit', this._onSubmit, true);
    document.removeEventListener('click', this._onClick, true);
    if (this.hint && this.hint.parentNode) this.hint.parentNode.removeChild(this.hint);
    this._ready = false;
  };

  CBC.prototype.checked = function (part) {
    var row = this.rows[part];
    return row ? row.querySelector('.cbc-input:checked, .cbc-jack-input:checked') : null;
  };
  CBC.prototype.matchTarget = function () {
    var face = this.checked('faceplate');
    if (!face || !this.rows.button) return null;
    return this.rows.button.querySelector('.cbc-input[value="' + face.value.replace(/"/g, '\\"') + '"]');
  };
  CBC.prototype.complete = function () {
    var self = this;
    return PARTS.every(function (p) { return !!self.checked(p); });
  };

  CBC.prototype.update = function () {
    var self = this, done = 0;
    PARTS.forEach(function (p) {
      var input = self.checked(p);
      var row = self.rows[p];
      if (input) done++;
      if (row) {
        row.classList.toggle('is-done', !!input);
        var v = row.querySelector('[data-cbc-value], [data-cbc-jack-value]');
        if (v) v.textContent = input ? (input.dataset.label || input.value) : 'Choose a colour';
      }
    });
    // "Same as faceplate" only shows when that colour exists as a centre button (e.g. not for ombre faceplates).
    if (this.matchBtn) this.matchBtn.hidden = !this.matchTarget();
    var ok = done === PARTS.length;
    this.classList.toggle('is-complete', ok);
    if (this.statusEl) {
      this.statusEl.textContent = ok
        ? 'All 5 colours chosen. You\u2019re good to add to cart.'
        : 'Pick a colour for all ' + PARTS.length + ' parts to add to cart (' + done + ' of ' + PARTS.length + ' chosen).';
      this.statusEl.classList.toggle('is-ok', ok);
    }
    if (this.form) {
      this.form.classList.toggle('cbc-locked', !ok);
      var btns = document.querySelectorAll('.single-add-to-cart-button');
      Array.prototype.forEach.call(btns, function (b) {
        if (b.form === self.form || self.form.contains(b)) {
          if (ok) { b.classList.remove('cbc-btn-locked'); if (!b.classList.contains('loading')) b.removeAttribute('aria-disabled'); }
          else { b.classList.add('cbc-btn-locked'); b.setAttribute('aria-disabled', 'true'); }
        }
      });
    }
    if (this.hint) this.hint.hidden = ok;
  };

  CBC.prototype.nag = function () {
    var self = this, first = null;
    PARTS.forEach(function (p) { if (!first && !self.checked(p)) first = self.rows[p]; });
    if (this.statusEl) {
      this.statusEl.classList.remove('is-nag'); void this.statusEl.offsetWidth; this.statusEl.classList.add('is-nag');
    }
    if (first) {
      first.classList.add('cbc-row--nag');
      setTimeout(function () { first.classList.remove('cbc-row--nag'); }, 1600);
      try { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { first.scrollIntoView(); }
      var firstInput = first.querySelector('.cbc-input, .cbc-jack-input');
      if (firstInput) { try { firstInput.focus({ preventScroll: true }); } catch (e) {} }
    }
  };

  customElements.define('custom-build-colours', CBC);
})();
